/* Blankspot · ficha v6
   Stock en verde, packs con color por unidad, fechas de envío reales
   y captura del cumpleaños después de apuntarse a la newsletter.
   No depende de ninguna app: solo del JSON que imprime snippets/bs-v6.liquid. */
(function () {
  if (window.__bsV6) return;            // por si el snippet se pinta más de una vez
  window.__bsV6 = true;
  var nodo = document.getElementById('bs-v6-datos');
  if (!nodo) return;
  var D = JSON.parse(nodo.textContent);

  /* ---------- dinero, con el formato de la tienda ---------- */
  function dinero(centimos) {
    var n = centimos / 100;
    var conComa = n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    var conPunto = n.toFixed(2);
    var sinDec = Math.round(n).toString();
    return (D.formatoDinero || '{{amount_with_comma_separator}} €')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, conComa)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sinDec)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sinDec)
      .replace(/\{\{\s*amount\s*\}\}/g, conPunto);
  }

  /* ---------- colores planos, sin brillos ---------- */
  var TINTES = {
    'dorado': '#D4AF37', 'plateado': '#C2C5C9', 'blanco': '#FFFFFF', 'negro': '#1A1A1A',
    'mostaza': '#E0A81F', 'rojito': '#E54633', 'rojo': '#E54633', 'turquesa': '#32D5C8',
    'beige': '#EAD8AB', 'verdecito': '#8CA966', 'coffee': '#8A601F', 'gilda': '#427833',
    'naranja': '#E8722B', 'amarillo mantequilla': '#F5EA84'
  };
  function tinte(titulo) {
    var k = (titulo || '').toLowerCase().trim();
    for (var n in TINTES) if (k.indexOf(n) !== -1) return TINTES[n];
    return 'rgba(0,0,0,.12)';
  }

  /* ---------- variante seleccionada ---------- */
  var vActual = D.variantes.filter(function (v) { return v.id === D.actual; })[0] || D.variantes[0];
  function inputVariante() {
    return document.querySelector('form[action*="/cart/add"] input[name="id"]');
  }
  function alCambiarVariante(cb) {
    document.addEventListener('change', function () {
      setTimeout(function () {
        var i = inputVariante(); if (!i) return;
        var v = D.variantes.filter(function (x) { return String(x.id) === String(i.value); })[0];
        if (v && v.id !== vActual.id) { vActual = v; cb(); }
      }, 60);
    }, true);
  }

  /* ================= 1. AVISO DE STOCK ================= */
  var cajaStock = document.querySelector('[data-bs="stock"]');
  function pintaStock() {
    if (!cajaStock) return;
    var t = cajaStock.querySelector('[data-bs="stock-txt"]');
    if (!vActual.a) {
      cajaStock.dataset.estado = 'agotado';
      t.textContent = 'Agotado ahora mismo';
      return;
    }
    cajaStock.dataset.estado = 'ok';
    if (vActual.q > 0 && vActual.q < D.avisoStock) {
      t.textContent = vActual.q === 1 ? 'Solo queda 1 en stock' : 'Solo ' + vActual.q + ' en stock';
    } else {
      t.textContent = 'En stock · sale en el próximo envío';
    }
  }

  /* ================= 2. PACKS ================= */
  var cajaPacks = document.querySelector('[data-bs="packs"]');
  var packSel = 0;
  var reparto = [];   // color elegido para cada unidad de cada pack

  function disponibles(v) { return v.a ? (v.q > 0 ? v.q : 99) : 0; }
  function totalDisponible() {
    return D.variantes.reduce(function (s, v) { return s + disponibles(v); }, 0);
  }
  function repartoInicial() {
    reparto = D.packs.map(function (p) {
      var usados = {}, salida = [];
      for (var u = 0; u < p.uds; u++) {
        var elegida = null;
        for (var k = 0; k < D.variantes.length; k++) {
          var v = D.variantes[(u + k) % D.variantes.length];
          if ((usados[v.id] || 0) < disponibles(v)) { elegida = v; break; }
        }
        if (!elegida) elegida = vActual;
        usados[elegida.id] = (usados[elegida.id] || 0) + 1;
        salida.push(elegida.id);
      }
      return salida;
    });
    if (reparto[0]) reparto[0][0] = vActual.id;
  }

  function precios(i) {
    var p = D.packs[i];
    var bruto = reparto[i].reduce(function (s, id) {
      var v = D.variantes.filter(function (x) { return x.id === id; })[0] || vActual;
      return s + v.p;
    }, 0);
    var neto = Math.round(bruto * (100 - p.dto) / 100);
    return { bruto: bruto, neto: neto, ahorro: bruto - neto };
  }

  function pintaPacks() {
    if (!cajaPacks) return;
    var html = '<p class="bs-packs__tit">' + D.textos.tituloPacks + '</p>';
    D.packs.forEach(function (p, i) {
      var pr = precios(i);
      var gratis = D.envioGratis > 0 && pr.neto >= D.envioGratis;
      var falta = Math.max(0, D.envioGratis - pr.neto);
      var sinStock = p.uds > totalDisponible();
      var cintas = '';
      if (p.dto) cintas += '<span class="bs-pack__badge">−' + p.dto + '%</span>';
      if (gratis) cintas += '<span class="bs-pack__badge bs-pack__badge--envio">Envío gratis</span>';

      var ahorro = '';
      if (pr.ahorro > 0 && gratis) ahorro = 'Ahorras ' + dinero(pr.ahorro) + ' y el envío';
      else if (pr.ahorro > 0) ahorro = 'Ahorras ' + dinero(pr.ahorro);
      else if (gratis) ahorro = 'Te ahorras el envío';

      var unidades = '';
      if (D.variantes.length > 1 && p.uds > 1) {   // el color de 1 ud ya lo elige el tema
        for (var u = 0; u < p.uds; u++) {
          var chips = D.variantes.map(function (v) {
            var usados = reparto[i].filter(function (id, j) { return id === v.id && j !== u; }).length;
            var lleno = usados >= disponibles(v) && reparto[i][u] !== v.id;
            var nombre = v.t + (lleno ? ' (agotado)' : '');
            return '<button type="button" class="bs-chip" data-pack="' + i + '" data-ud="' + u + '"' +
              ' data-var="' + v.id + '"' + (lleno ? ' disabled' : '') +
              ' title="' + nombre + '" aria-label="' + nombre + '"' +
              ' aria-pressed="' + (reparto[i][u] === v.id) + '">' +
              '<span class="bs-chip__pt" style="background:' + tinte(v.t) + '"></span></button>';
          }).join('');
          unidades += '<div class="bs-ud"><span class="bs-ud__n">Unidad ' + (u + 1) + '</span>' +
            '<span class="bs-chips">' + chips + '</span></div>';
        }
      }

      html += '<div class="bs-pack" aria-selected="' + (i === packSel) + '"' + (sinStock ? ' data-sinstock="true"' : '') + '>' +
        '<button type="button" class="bs-pack__cab" data-sel="' + i + '"' + (sinStock ? ' disabled' : '') + '>' +
          '<span class="bs-pack__radio"></span>' +
          '<span class="bs-pack__txt"><span class="bs-pack__n">' + p.nombre +
            cintas + '</span>' +
            '<span class="bs-pack__s">' + (sinStock ? 'No hay stock para este pack' : p.sub) + '</span></span>' +
          '<span class="bs-pack__pre"><span class="bs-pack__p">' + dinero(pr.neto) + '</span>' +
            (p.dto ? '<span class="bs-pack__antes">' + dinero(pr.bruto) + '</span>' : '') + '</span>' +
        '</button>' +
        '<div class="bs-pack__cuerpo">' + unidades +
          '<div class="bs-pack__pie">' +
            (ahorro ? '<span class="bs-ahorro">' + ahorro + '</span>' : '<span></span>') +
            '<span class="bs-pack__total">' + p.uds + (p.uds === 1 ? ' unidad · ' : ' unidades · ') +
            '<b>' + dinero(pr.neto) + '</b></span></div>' +
          (D.envioGratis > 0 ? '<div class="bs-gratis">' +
            (falta > 0 ? 'Te faltan ' + dinero(falta) + ' para el envío gratis' : 'Envío gratis incluido') +
            '<span class="bs-gratis__pista"><span class="bs-gratis__relleno" style="width:' +
            Math.min(100, pr.neto / D.envioGratis * 100) + '%"></span></span></div>' : '') +
          (p.uds > 1 ? '<button type="button" class="bs-packs__btn" data-anadir="' + i + '">' +
            D.textos.botonPack.replace('{pack}', p.nombre.toLowerCase()) + ' · ' + dinero(pr.neto) + '</button>' +
            (p.dto && !p.cod ? '<p class="bs-packs__aviso">' + D.textos.sinCodigo + '</p>' : '') : '') +
        '</div></div>';
    });
    cajaPacks.innerHTML = html;

    cajaPacks.querySelectorAll('[data-sel]').forEach(function (b) {
      b.addEventListener('click', function () { packSel = +b.dataset.sel; pintaPacks(); });
    });
    cajaPacks.querySelectorAll('.bs-chip').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        var i = +b.dataset.pack, u = +b.dataset.ud, id = +b.dataset.var;
        reparto[i][u] = id;
        pintaPacks();
      });
    });
    cajaPacks.querySelectorAll('[data-anadir]').forEach(function (b) {
      b.addEventListener('click', function () { anade(+b.dataset.anadir, b); });
    });
  }

  function anade(i, boton) {
    var cuenta = {};
    reparto[i].forEach(function (id) { cuenta[id] = (cuenta[id] || 0) + 1; });
    var items = Object.keys(cuenta).map(function (id) { return { id: +id, quantity: cuenta[id] }; });
    boton.disabled = true; boton.textContent = 'Añadiendo…';
    fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json(); })
      .then(function () {
        var cod = D.packs[i].cod;
        window.location.href = cod ? '/discount/' + encodeURIComponent(cod) + '?redirect=/cart' : '/cart';
      })
      .catch(function () { boton.disabled = false; boton.textContent = 'No se ha podido añadir'; });
  }

  /* ================= 3. ENVÍO: reloj y fechas ================= */
  var cajaEnvio = document.querySelector('[data-bs="envio"]');
  var MESES = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
  var DIAS = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

  function ahoraEnTienda() {            // la hora de corte es la de la tienda, no la del móvil
    try { return new Date(new Date().toLocaleString('en-US', { timeZone: D.zona })); }
    catch (e) { return new Date(); }
  }
  function proximoCorte(ahora) {
    for (var i = 0; i < 12; i++) {
      var c = new Date(ahora); c.setDate(ahora.getDate() + i); c.setHours(D.corteHora, 0, 0, 0);
      if (D.corteDias.indexOf(c.getDay()) !== -1 && c > ahora) return c;
    }
    return ahora;
  }
  function masHabiles(fecha, n) {
    var d = new Date(fecha), q = 0;
    while (q < n) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) q++; }
    return d;
  }
  function fmt(d) { return DIAS[d.getDay()] + ' ' + d.getDate() + ' ' + MESES[d.getMonth()]; }

  function pintaEnvio() {
    if (!cajaEnvio) return;
    var ahora = ahoraEnTienda(), corte = proximoCorte(ahora), ms = corte - ahora;
    var h = Math.floor(ms / 36e5), m = Math.floor(ms % 36e5 / 6e4), s = Math.floor(ms % 6e4 / 1000);
    var hoy = corte.toDateString() === ahora.toDateString();
    cajaEnvio.querySelector('[data-bs="reloj"]').innerHTML = hoy
      ? D.textos.relojHoy.replace('{t}', '<b>' + h + ' h ' + ('0' + m).slice(-2) + ' min ' + ('0' + s).slice(-2) + ' s</b>')
      : D.textos.relojOtroDia.replace('{d}', '<b>' + fmt(corte) + '</b>');
    cajaEnvio.querySelector('[data-bs="f-pedido"]').textContent = hoy ? 'Hoy' : fmt(corte);
    cajaEnvio.querySelector('[data-bs="f-envio"]').textContent = fmt(corte) + ' – ' + fmt(masHabiles(corte, 1));
    cajaEnvio.querySelector('[data-bs="f-entrega"]').textContent = fmt(masHabiles(corte, 3)) + ' – ' + fmt(masHabiles(corte, 4));
  }

  /* ================= 4. CUMPLEAÑOS ================= */
  /* Cuando alguien se apunta a la newsletter, el formulario de Shopify recarga la página.
     Guardamos su email antes de irnos y, al volver, le pedimos el cumpleaños y lo mandamos
     a Klaviyo como propiedad "Birthday", que es la que dispara el flow de cumpleaños. */
  var LLAVE = 'bs_nl_email';

  function guardaEmailAlEnviar() {
    var form = document.querySelector('form.bs-nl__form');
    if (!form) return;
    form.addEventListener('submit', function () {
      var i = form.querySelector('input[type="email"]');
      try { if (i && i.value) localStorage.setItem(LLAVE, i.value.trim()); } catch (e) {}
    });
  }

  function mandaCumple(email, fecha) {
    return fetch('https://a.klaviyo.com/client/profiles/?company_id=' + encodeURIComponent(D.klaviyo), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: { type: 'profile', attributes: { email: email, properties: { Birthday: fecha } } }
      })
    });
  }

  function pintaCumple() {
    var caja = document.querySelector('[data-bs="cumple"]');
    var ok = document.querySelector('[data-bs-nl-ok]') ||
             location.search.indexOf('customer_posted=true') !== -1;
    if (!caja || !ok || !D.klaviyo) return;
    var email = '';
    try { email = localStorage.getItem(LLAVE) || ''; } catch (e) {}
    if (!email) return;

    caja.hidden = false;
    var det = caja.closest('details');
    if (det) det.open = true;
    var form = document.querySelector('form.bs-nl__form');   // ya se ha apuntado
    if (form) form.hidden = true;
    var nota = document.querySelector('.bs-nl__note');
    if (nota) nota.textContent = 'Ya estás dentro. Tu código va camino del correo.';

    var dia = caja.querySelector('[data-bs="cumple-dia"]');
    var mes = caja.querySelector('[data-bs="cumple-mes"]');
    var btn = caja.querySelector('[data-bs="cumple-btn"]');
    for (var d = 1; d <= 31; d++) dia.add(new Option(d, d));
    var nombres = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio',
                   'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
    nombres.forEach(function (n, k) { mes.add(new Option(n, k + 1)); });

    btn.addEventListener('click', function () {
      if (!dia.value || !mes.value) return;
      btn.disabled = true; btn.textContent = 'Guardando…';
      var fecha = '1900-' + ('0' + mes.value).slice(-2) + '-' + ('0' + dia.value).slice(-2);
      mandaCumple(email, fecha).then(function () {
        caja.innerHTML = '<p class="bs-cumple__ok">Apuntado. Te escribimos ese día.</p>';
        try { localStorage.removeItem(LLAVE); } catch (e) {}
      }).catch(function () {
        btn.disabled = false; btn.textContent = 'Guardar';
      });
    });
  }

  /* ---------- arranque ---------- */
  repartoInicial(); pintaStock(); pintaPacks(); pintaEnvio();
  guardaEmailAlEnviar(); pintaCumple();
  if (cajaEnvio) setInterval(pintaEnvio, 1000);
  alCambiarVariante(function () { repartoInicial(); pintaStock(); pintaPacks(); });
})();
